import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h5 text-secondary mb-4" }, "Hlavní náležitosti", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "order-1 order-lg-0 col-lg-8 col-xxl-9 offset-lg-4 offset-xxl-3 mb-1 text-secondary small"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-xxl-3 col-form-label d-none d-lg-block" }, "Typ faktury", -1)
const _hoisted_7 = { class: "col-lg-8 col-xxl-9 d-flex align-items-center mt-3 mt-lg-0" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "invoice-proforma"
}, " Jedná se o zálohovou (proforma) fakturu ", -1)
const _hoisted_10 = {
  key: 1,
  class: "border-bottom pt-4 mb-4 d-none d-lg-block"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-issueDate",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Datum vystavení", -1)
const _hoisted_13 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-dueDate",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Datum splatnosti", -1)
const _hoisted_18 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "order-1 order-lg-0 col-lg-8 col-xxl-9 offset-lg-4 offset-xxl-3 small mb-1" }
const _hoisted_23 = { class: "link-secondary" }
const _hoisted_24 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-invoiceNumber",
  class: "order-0 order-lg-1 col-lg-4 col-xxl-3 col-form-label"
}, "Číslo faktury", -1)
const _hoisted_26 = { class: "order-2 col-lg-8 col-xxl-9" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-paymentType",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Způsob platby", -1)
const _hoisted_31 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "Převodem" }, "Převodem", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "Hotově" }, "Hotově", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "Dobírkou" }, "Dobírkou", -1)
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-currency",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Měna", -1)
const _hoisted_39 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "CZK" }, "CZK - Česká koruna", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "EUR" }, "EUR - Euro", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "USD" }, "USD - US Dollar", -1)
const _hoisted_43 = { class: "invalid-feedback" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-textBeforeItems",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, " Text před položkami faktury ", -1)
const _hoisted_47 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_48 = { class: "invalid-feedback" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "h5 mt-5 text-secondary mb-4" }, "Fakturované položky", -1)
const _hoisted_51 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_52 = { style: {"min-width":"180px"} }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-plus-circle me-1",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "Nový řádek", -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = {
  class: "h4 text-success border-top border-2 border-success text-end w-100 pt-3",
  style: {"max-width":"600px"}
}
const _hoisted_57 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Autocomplete = _resolveComponent("Autocomplete")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InvoiceItemField = _resolveComponent("InvoiceItemField")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    "validation-schema": _ctx.schema,
    "initial-values": _ctx.invoice,
    class: "p-4 p-lg-5 bg-white rounded-3 border"
  }, {
    default: _withCtx(({ errors, values }) => [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.invoice?.expand)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.invoice.expand.customer.name) + " (IČO: " + _toDisplayString(_ctx.invoice.expand.customer.companyId) + ") ", 1))
            : _createCommentVNode("", true),
          _createVNode(_component_Autocomplete, {
            name: "customer",
            errors: errors,
            label: "Odběratel",
            "search-handler": _ctx.searchHandler,
            "label-wrapper": "order-0 order-lg-1 col-lg-4 col-xxl-3 col-form-label",
            "input-wrapper": "order-2 col-lg-8 col-xxl-9"
          }, {
            "button-group": _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNewCustomer && _ctx.handleNewCustomer(...args))),
                class: "btn btn-outline-secondary"
              }, "Nový odběratel ")
            ]),
            _: 2
          }, 1032, ["errors", "search-handler"])
        ]),
        _hoisted_4,
        (!_ctx.invoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.isProforma,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isProforma) = $event)),
                    value: true,
                    class: _normalizeClass([{ 'is-invalid' : errors.proforma }, "form-check-input"]),
                    name: "proforma",
                    type: "checkbox",
                    id: "invoice-proforma"
                  }, null, 8, ["modelValue", "class"]),
                  _hoisted_9
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.invoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Field, {
              modelValue: _ctx.issueDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.issueDate) = $event)),
              onChange: _ctx.handleIssueDateChanged,
              class: _normalizeClass([{ 'is-invalid' : errors.issueDate }, "form-control"]),
              name: "issueDate",
              id: "invoice-issueDate"
            }, null, 8, ["modelValue", "onChange", "class"]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(errors.issueDate), 1)
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Field, {
              modelValue: _ctx.dueDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dueDate) = $event)),
              name: "dueDate",
              class: _normalizeClass(["form-control", { 'is-invalid' : errors.dueDate }]),
              id: "invoice-dueDate"
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("div", _hoisted_19, _toDisplayString(errors.dueDate), 1)
          ])
        ]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", null, _toDisplayString(_ctx.proformaPrefix) + _toDisplayString(_ctx.nextInvoiceNumberPretty), 1),
              (_ctx.suggestedInvoiceNumberPretty)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _createTextVNode(" | "),
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleNewInvoiceNumber && _ctx.handleNewInvoiceNumber(...args)), ["prevent"])),
                      href: "#",
                      class: "link-danger"
                    }, " Aktualizovat na: " + _toDisplayString(_ctx.suggestedInvoiceNumberPretty), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Field, {
              modelValue: _ctx.invoiceNumber,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.invoiceNumber) = $event)),
              name: "invoiceNumber",
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid' : errors.invoiceNumber }]),
              id: "invoice-invoiceNumber"
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("div", _hoisted_27, _toDisplayString(errors.invoiceNumber), 1)
          ])
        ]),
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_Field, {
              value: _ctx.invoice?.paymentType || 'Převodem',
              class: _normalizeClass([{ 'is-invalid' : errors.paymentType }, "form-select"]),
              as: "select",
              name: "paymentType",
              id: "invoice-paymentType"
            }, {
              default: _withCtx(() => [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34
              ]),
              _: 2
            }, 1032, ["value", "class"]),
            _createElementVNode("div", _hoisted_35, _toDisplayString(errors.paymentType), 1)
          ])
        ]),
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_Field, {
              value: _ctx.invoice?.currency || 'CZK',
              as: "select",
              name: "currency",
              class: _normalizeClass(["form-select", { 'is-invalid' : errors.currency }]),
              id: "invoice-paymentType"
            }, {
              default: _withCtx(() => [
                _hoisted_40,
                _hoisted_41,
                _hoisted_42
              ]),
              _: 2
            }, 1032, ["value", "class"]),
            _createElementVNode("div", _hoisted_43, _toDisplayString(errors.paymentType), 1)
          ])
        ]),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Field, {
              as: "textarea",
              name: "textBeforeItems",
              class: _normalizeClass(["form-control", { 'is-invalid' : errors.textBeforeItems }]),
              id: "invoice-textBeforeItems"
            }, null, 8, ["class"]),
            _createElementVNode("div", _hoisted_48, _toDisplayString(errors.textBeforeItems), 1)
          ])
        ]),
        _hoisted_49
      ]),
      _hoisted_50,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (_openBlock(), _createBlock(_component_InvoiceItemField, {
              key: item.fieldUid,
              item: item,
              first: index === 0,
              last: index === _ctx.invoiceItems.length - 1,
              count: _ctx.invoiceItems.length,
              errors: errors,
              onOnRemove: _ctx.handleItemRemove,
              onOnMove: _ctx.handleItemMove
            }, null, 8, ["item", "first", "last", "count", "errors", "onOnRemove", "onOnMove"]))
          ]))
        }), 256)),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleItemAdd && _ctx.handleItemAdd(...args)), ["prevent"])),
              class: "rounded-3 py-2 px-4 text-center border-0 bg-secondary bg-opacity-10 text-secondary"
            }, _hoisted_55)
          ]),
          _createElementVNode("div", _hoisted_56, _toDisplayString(values.currency && _ctx.toFormattedPrice(_ctx.sumPrice(values.items), values.currency)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_SubmitButton, {
          "btn-title": _ctx.invoice ? 'Uložit změny' : 'Vytvořit fakturu',
          loading: _ctx.loading,
          classes: "w-100 w-lg-auto px-4"
        }, null, 8, ["btn-title", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema", "initial-values"]))
}